import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import moment from 'moment';

export function dateInThePastValidator(dateFormat: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const invalid = moment(control.value, dateFormat).isSameOrAfter(moment().startOf('day'));
    return invalid ? {futureDate: {value: control.value}} : null;
  };
}
